var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.filters
    ? _c(
        "w-card",
        { staticClass: "card", attrs: { "max-width": "800" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("SearchTitle")))]),
          _c(
            "w-scroll-view",
            {
              staticClass: "content",
              style: { minHeight: "180px" },
              attrs: { tag: "w-card-content" },
            },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-tabs", {
                        staticClass: "mb no-margin",
                        attrs: { tabs: _vm.tabs },
                        on: {
                          input: function ($event) {
                            return _vm.tabChange($event)
                          },
                        },
                        model: {
                          value: _vm.state.filterModalActiveTab,
                          callback: function ($$v) {
                            _vm.$set(_vm.state, "filterModalActiveTab", $$v)
                          },
                          expression: "state.filterModalActiveTab",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                { staticClass: "mt" },
                [
                  _vm.state.filterModalActiveTab == 0
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            ref: "quickSearch",
                            attrs: {
                              value: _vm.filters.searchQuery,
                              label: _vm.$t("common.search"),
                              autofocus: "",
                              fancy: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onSearchQueryInput($event)
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.submit()
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "search-settings-wrapper" },
                            [
                              _c(
                                "w-row",
                                {
                                  staticClass: "btt-search-settings",
                                  nativeOn: {
                                    click: function ($event) {
                                      _vm.showSearchSettings =
                                        !_vm.showSearchSettings
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$ct("search-settings")) +
                                      " "
                                  ),
                                  _c("w-fa", {
                                    attrs: { icon: _vm.searchIcon },
                                  }),
                                ],
                                1
                              ),
                              _vm.showSearchSettings
                                ? _c(
                                    "div",
                                    { staticClass: "search-info" },
                                    [
                                      _c(
                                        "w-row",
                                        { staticClass: "mts" },
                                        [
                                          _c("w-checkbox", {
                                            attrs: {
                                              label: _vm.$ct(
                                                "search-auto-wildcard"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.filters.autoWildCardSearch,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "autoWildCardSearch",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.autoWildCardSearch",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-row",
                                        {},
                                        [
                                          _c("w-checkbox", {
                                            attrs: {
                                              label:
                                                _vm.$ct("search-all-colums"),
                                            },
                                            model: {
                                              value:
                                                _vm.filters.searchByAllColumns,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "searchByAllColumns",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.searchByAllColumns",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.state.filterModalActiveTab == 1
                    ? _c(
                        "div",
                        { style: { width: "100%" } },
                        [
                          _vm.filters.filters[0] && _vm.filters.filters[0].Field
                            ? _c(
                                "ul",
                                { staticClass: "filter-list cf" },
                                [
                                  _vm._l(
                                    _vm.filters.filters,
                                    function (filter, i) {
                                      return _c(
                                        "li",
                                        {
                                          key: i,
                                          class: {
                                            active: _vm.activeFilterTab == i,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.activeFilterTab = i
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getFriendlyName(
                                                  filter.Field
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c("w-fa", {
                                            attrs: { icon: "times" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.removeFilter(i)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm.filters.filters[0] &&
                                  _vm.filters.filters[0].Field
                                    ? _c(
                                        "li",
                                        {
                                          staticClass: "no-style",
                                          on: {
                                            click: function ($event) {
                                              return _vm.addFilter()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "w-button",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: _vm.$ct("add-filter"),
                                                  expression:
                                                    "$ct('add-filter')",
                                                },
                                              ],
                                              attrs: { round: "", sm: "" },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "plus" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.activeFilter
                            ? _c("app-filter-edit", {
                                attrs: {
                                  model: _vm.currentModel,
                                  browse: _vm.state.browse,
                                },
                                model: {
                                  value: _vm.activeFilter,
                                  callback: function ($$v) {
                                    _vm.activeFilter = $$v
                                  },
                                  expression: "activeFilter",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }